// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__QjnJn","title":"InfoPanel_title__3pI9I","expanded":"InfoPanel_expanded__3BmG6","content":"InfoPanel_content__1Nk1k"};